var render = function render(){
  var _vm$selectedSegment, _vm$selectedSegment2, _vm$selectedSegment3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "spectrum-hero",
    class: _vm.spectrumHeroBackgroundImage,
    style: {
      marginTop: _vm.isEventBannerVisible ? '0px' : '90px'
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "p-0 d-flex flex-column justify-content-center align-items-center",
    style: {
      marginTop: _vm.marginTopStyle
    },
    attrs: {
      "xl": "4",
      "lg": "4",
      "md": "4",
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "mt-3 banner-info"
  }, [_c('div', {
    staticClass: "ml-2 mb-3"
  }, [_c('div', {
    staticClass: "mb-2 banner-info-main-text",
    class: _vm.bannerMainInfoTextClasses
  }, [_vm._v(_vm._s(_vm.infoTextMap[(_vm$selectedSegment = _vm.selectedSegment) !== null && _vm$selectedSegment !== void 0 ? _vm$selectedSegment : 'ProjectSpectrum'].mainText))]), _c('div', {
    staticClass: "banner-info-sub-text",
    class: _vm.primaryInfoSubTextClasses
  }, [_vm._v("What's in it for me?")])]), _c('div', {
    staticClass: "ml-2 mb-4"
  }, [_c('div', {
    staticClass: "d-flex flex-row justify-content-start align-items-start"
  }, [_c('img', {
    staticStyle: {
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../../../assets/images/logo/check.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "ml-2 banner-info-sub-text",
    class: _vm.secondaryInfoSubTextClasses
  }, [_vm._v(_vm._s(_vm.infoTextMap[(_vm$selectedSegment2 = _vm.selectedSegment) !== null && _vm$selectedSegment2 !== void 0 ? _vm$selectedSegment2 : 'ProjectSpectrum'].subText1))])]), _c('div', {
    staticClass: "mt-2 d-flex flex-row justify-content-start align-items-start"
  }, [_c('img', {
    staticStyle: {
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../../../assets/images/logo/check.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "ml-2 banner-info-sub-text",
    class: _vm.secondaryInfoSubTextClasses
  }, [_vm._v(_vm._s(_vm.infoTextMap[(_vm$selectedSegment3 = _vm.selectedSegment) !== null && _vm$selectedSegment3 !== void 0 ? _vm$selectedSegment3 : 'ProjectSpectrum'].subText2))])])]), _c('BannerButtons', {
    attrs: {
      "buttonTitle": _vm.buttonLabel,
      "button-color": _vm.buttonColorMap[_vm.selectedBlueprint],
      "vButtonFirstItemClass": 'banner-buttons-xl-lg-md',
      "vButtonSecondItemClass": 'banner-buttons-xl-lg-md',
      "bannerButtonClasses": 'ml-2 mb-3 d-none d-xl-flex d-lg-flex d-md-flex flex-row justify-content-start'
    },
    on: {
      "goToBlueprintItem": _vm.autoScrollToBlueprint
    }
  })], 1)]), _c('v-col', {
    staticClass: "p-0",
    attrs: {
      "xl": "8",
      "lg": "8",
      "md": "8",
      "cols": "12"
    }
  }, [_c('SpectrumWheel', {
    attrs: {
      "selectedSegmentName": _vm.selectedBlueprint
    },
    on: {
      "receive-selected-segment": _vm.receiveSegmentName,
      "back-button-click": _vm.handleBackButtonClick
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex d-xs-flex d-none d-sm-flex d-md-none d-lg-none d-xl-none"
  }, [_c('v-col', {
    staticClass: "p-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('BannerButtons', {
    attrs: {
      "buttonTitle": _vm.buttonLabel,
      "button-color": _vm.buttonColorMap[_vm.selectedBlueprint],
      "bannerButtonClasses": _vm.mobileBannerButtonClassesComputed,
      "vButtonSecondItemClass": _vm.buttonLabel && 'mt-3'
    },
    on: {
      "goToBlueprintItem": _vm.autoScrollToBlueprint
    }
  })], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }